module.exports = __webpack_public_path__ + "img/smile-good.5b45da83.svg";